import type { SessionUser } from '@movo/contracts/api/auth';
import { readTokenPayload } from '@/shared/lib/tenantSession';
import { isTokenExpired } from '../model/token';
import { fetchMe, refresh } from './authApi';

const SESSION_TIMEOUT_MS = 10_000;

export const storeToken = (token: string) => localStorage.setItem('token', token);
export const clearToken = () => localStorage.removeItem('token');

// Senza un limite, i retry di apiClient terrebbero "Verifica accesso…" per minuti.
const withTimeout = <T>(promise: Promise<T>) =>
  Promise.race([
    promise,
    new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('auth_timeout')), SESSION_TIMEOUT_MS)
    ),
  ]);

/**
 * L'utente della sessione salvata, o `null` se non c'è o non si può verificare
 * (token scaduto senza refresh, 401, rete, timeout): in quel caso il token sparisce.
 */
export async function fetchSession(): Promise<SessionUser | null> {
  if (!localStorage.getItem('token')) return null;
  try {
    if (isTokenExpired(readTokenPayload(), Date.now())) {
      storeToken(await refresh());
    }
    return await withTimeout(fetchMe());
  } catch {
    clearToken();
    return null;
  }
}
